import React, { useState } from 'react';
import { PawPrint, Cake, Pencil } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

export const PetBirthday = () => {
  const { user, updatePet } = useAuth();
  const pet = user?.pets?.[0];
  const [editing, setEditing] = useState(!pet);
  const [name, setName] = useState(pet?.name || '');
  const [birthday, setBirthday] = useState(pet?.birthday || '');
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!name.trim() || !birthday) return;
    setSaving(true);
    try {
      await updatePet({ pet_name: name.trim(), pet_birthday: birthday });
      toast.success('¡Listo! Te avisaremos con un regalo en su cumpleaños');
      setEditing(false);
    } catch {
      toast.error('No se pudo guardar');
    } finally {
      setSaving(false);
    }
  };

  const birthdayLabel = pet?.birthday
    ? new Date(`${pet.birthday}T12:00:00`).toLocaleDateString('es-CO', { day: 'numeric', month: 'long' })
    : '';

  return (
    <section className="mb-12 bg-[#FFF7EE] border border-[#F3D9C4] rounded-2xl p-5" data-testid="pet-birthday-section">
      <div className="flex items-center gap-2 mb-1">
        <Cake className="w-5 h-5 text-[#D47A4A]" />
        <h2 className="font-display font-semibold text-lg text-[#1C1917]">Cumpleaños de tu mascota</h2>
      </div>
      <p className="text-sm text-[#57534E] mb-4">Ese día te enviamos un cupón sorpresa del 10% para celebrarlo 🎂</p>

      {!editing && pet ? (
        <div className="flex flex-wrap items-center gap-3" data-testid="pet-birthday-summary">
          <span className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 text-sm font-semibold text-[#1C1917] border border-[#F3D9C4]">
            <PawPrint className="w-4 h-4 text-[#2A5C43]" /> {pet.name} · {birthdayLabel}
          </span>
          <button onClick={() => setEditing(true)} className="text-xs text-[#D47A4A] inline-flex items-center gap-1 hover:underline" data-testid="pet-birthday-edit">
            <Pencil className="w-3 h-3" /> Editar
          </button>
        </div>
      ) : (
        <form onSubmit={save} className="flex flex-col sm:flex-row gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre de tu mascota" className="h-11 rounded-xl bg-white" data-testid="pet-name-input" />
          <Input type="date" value={birthday} max={new Date().toISOString().slice(0, 10)} onChange={(e) => setBirthday(e.target.value)} className="h-11 rounded-xl bg-white sm:w-48" data-testid="pet-birthday-input" />
          <Button type="submit" disabled={saving || !name.trim() || !birthday} className="h-11 rounded-full bg-[#D47A4A] hover:bg-[#B86538] text-white px-6" data-testid="pet-birthday-save">
            {saving ? 'Guardando…' : 'Guardar'}
          </Button>
        </form>
      )}
    </section>
  );
};
